import * as React from "react"
import {useEffect, useState} from "react"
import {graphql} from "gatsby";
import {Box, Container, Flex, Grid, GridItem, keyframes} from "@chakra-ui/react"
import PostBreadcrump from "../components/common/blogPosts/post.breadcrump";
import Separator from "../components/common/separator/separator";
import Author from "../components/common/author/author";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import GoBackPodcasts from "../components/common/goBackPodcasts/goBackPodcasts";

import AuthorSection from "../components/common/blogPosts/authorSection"
import PrevNext from '../components/page/knowledgebase/prevNext'
import Interested from '../components/page/knowledgebase/interestedPost'
import ContactForm from "../components/common/footerContact/contactForm";
import HeaderWithLine from "../components/common/headerWithLine/headerWithLine";
import Close from "../components/common/tableOfContents/images/close.svg";
import FormToggle from "../components/common/footerContact/images/toggleForm.svg";
import LdJsonArticle from "../components/common/ldJson/scriptArticle";
import Spotify from "../components/common/blogPosts/images/spotify.svg";
import Yt from "../components/common/blogPosts/images/yt.svg";
import FaqHTML from "../components/common/faq/faq";
import PostContent from "../components/common/postContent/postContent2";
import Footnotes from "../components/common/footnotes/footnotes";
import Arrow from "../components/common/goBackPodcasts/images/arrow.svg";
import RatingComponent from "../components/common/blogPosts/ratingComponent";

export default function KnowlagebaseHtml(props) {

	const article = props.article
	const lang = article?.language?.code ?? 'PL'

	const interested = (props.interested) ? props.interested.nodes : null

	const author = (article.author) ? article.author.node : null
	const img = (article.featuredImage && article.featuredImage.node) ? getImage(article.featuredImage.node.localFile) : null
	const other = (props.other) ? props.other.edges.filter(other => (other.node) ? other.node.id === article.id : null)[0] : null

	useEffect(() => {
		const onScroll = () => document.querySelector('body').classList.add('scrolled');
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	const [mobileFormActive, setMobileFormActive] = useState(false)

	const openMobileForm = () => {
		setMobileFormActive(true)
	}
	const closeMobileForm = () => {
		setMobileFormActive(false)
	}


	const element = props.post ? props.post : props.article ? props.article : null
	const elementAcf = props.post ? props.post.postACF : props.article ? props.article.knowledgeBaseACF : null

	const pulse = keyframes`  
      0%, 40% {box-shadow: 0 0 0 0 #67ccf8;}   
      60%, 100% {box-shadow: 0 0 0 14px transparent; } 
    `;
	const pulseAnimation = `${pulse} 6s infinite ease-in-out`;

	const articleTranslation = {
		modifeidText : {
			PL : 'Aktualizacja wpisu:',
			EN : 'Article updated at:'
		},
		date : {
			PL : 'datePL',
			EN : 'dateEN',
		},
		modifiedDate : {
			PL : 'modifiedPL',
			EN : 'modifiedEN',
		},
		listenText : {
			PL : 'Słuchaj w:',
			EN : 'Listen on:'
		}
	}
	const modified = article[articleTranslation.modifiedDate[lang]] !== article[articleTranslation.date[lang]] ? article[articleTranslation.modifiedDate[lang]] : null
	const readingTime = article?.readingTime?.time ?? '0'
	const seoH1 = article?.seo?.h1 ?? null
	const isFAQ = article.faqACF && article.faqACF.faq && article.faqACF.faq?.length > 0 && article.faqACF?.faq[0]?.question && article.faqACF?.faq[0]?.answer
	return (
		<>
			<Container mx={{ lg:'60px',xxl:'auto'}} maxW={{base:'100%',lg:'calc(100% - 120px)', xxl: 'container.xxl'}} px={{base:'20px', lg: '0'}}>
				<PostBreadcrump node={props.article} mb={{base:'0',lg:'40px'}}/>
				<LdJsonArticle post={article} author={author} />
				<Grid display={{base:'block', md:'grid'}} templateColumns={{ base: '1fr', lg: '0 1fr 0', xl:'1fr 768px max(350px, 25%) 1fr', laptop: '1fr 768px max(350px, 25%)', xxl: '320px 3fr 400px'}} gap={{base: '0'}} mb={'50px'} position={'relative'}>
					<GridItem mb={{base: '20px', lg: '0'}} className={'goBackPodcasts'} display={{base:'block', xxl:'block'}}>
						<GoBackPodcasts {...props} lang={lang} translation={articleTranslation}/>
					</GridItem>
					<GridItem
						sx={{
							'&:has(.custom-block-chapter)' : {
								overflow:'visible'

							}
						}}
					>
						<Container maxW={{base:'768px', xxl:'800px'}} p={'0'} px={{base:'auto', lg:'auto',xl:'2rem', xxl:'auto'}} className={'content'} id={'postContent'}>
							<Flex color={'gray.darker'} fontSize={'15px'} lineHeight={'19px'} justifyContent={'space-between'} alignItems={'center'} mb={'40px'}>
								<Flex alignItems={{ base: 'flex-start', lg: 'center'}} flexDirection={{ base: 'column', lg: 'row'}} >
									<Flex>
										{lang && lang === "PL" ? article.datePL : article.dateEN}
										<Separator h={'20px'} m={'0 20px'}/>
										<Box as={'span'}>{readingTime} min.</Box>
										<Separator h={'20px'} m={'0 20px'} display={{base:'none', lg: 'inline-block'}}/>
									</Flex>
									<Author author={article.author} type={'article'} fontSize={'15px'} m={'0'} mt={{ base: '20px',lg: '0'}}/>
								</Flex>
							</Flex>
							{modified &&
								<Box fontWeight={'500'} color={'gray.darker'}
									 mt={{base: '-30px', lg: '-10px', xxl: '-15px'}}
									 mb={{base: '40px', lg: '30px', xxl: '50px'}}>
									{ `${articleTranslation.modifeidText[lang]} ${modified}`}
								</Box>
							}
							<Box as="h1" mb="35px" fontSize={{base: '18px', lg: '36px'}}>{seoH1 ? seoH1 : article.title}</Box>
							{(elementAcf.spotify || elementAcf.youtube) &&
								<Flex display={{base: 'flex', xxl: 'none'}} alignItems={'center'}
									  justifyContent={'flex-start'} gap={'1rem'} mb={'2rem'}>
									{elementAcf.spotify &&
										<Flex as='a' href={elementAcf.spotify} alignItems={'center'} color={'#000 !important'} fontWeight={'600 !important'}
											  rel="noreferrer" target={'_blank'}
											  title={element.title}
											  mb={{base: '0', lg: '0'}} textDecoration={'none !important'}
											  _hover={{
												  '> .icon' : {
													  transform:'scale(1.1)'
												  },
												  '> .arrow' : {
													  transform:'translateX(5px)',
													  opacity:'1'
												  }
											  }}
										>
											<Box as={Spotify}
												 className={'icon'}
												 transition={'transform .35s ease'}
												 w={{base: '40px', lg: '60px'}}
												 h={{base: '40px', lg: '60px'}}
												 boxShadow={'0 10px 20px #0000001F'}
												 background={'#fff'}
												 padding={{base: '6px', lg: '13px'}}
												 borderRadius={'50%'}

											/>
											<Box display={{base:'none', lg:'inline-block'}} m={'0 .5rem 0 1rem'}>{articleTranslation.listenText[lang]}<Box as={'span'} display={{base: 'none', lg: 'inline-block'}}>&nbsp;Spotify</Box></Box>
											<Box as={Arrow} className={'arrow'}  display={{base:'none', lg:'block'}} mr={{base:'0', lg:'1rem'}} opacity={'0'} transition={'all .35s ease'}/>
										</Flex>
									}


									{elementAcf.youtube &&
										<Flex as='a' href={elementAcf.youtube} alignItems={'center'}
											  rel="noreferrer" target={'_blank'} textDecoration={'none !important'} color={'#000 !important'} fontWeight={'600 !important'}
											  _hover={{
												  '> .icon' : {
													  transform:'scale(1.1)'
												  },
												  '> .arrow' : {
													  transform:'translateX(5px)',
													  opacity:'1'
												  }
											  }}
										>
											<Box as={Yt}
												 className={'icon'}
												 transition={'transform .35s ease'}
												 w={{base: '40px', lg: '60px'}}
												 h={{base: '40px', lg: '60px'}}
												 boxShadow={'0 10px 20px #0000001F'}
												 background={'#fff'}
												 padding={{base: '6px', lg: '13px'}}
												 borderRadius={'50%'}
											/>
											<Box display={{base:'none', lg:'inline-block'}} m={'0 .5rem 0 1rem'}>{articleTranslation.listenText[lang]}<Box as={'span'} display={{base: 'none', lg: 'inline-block'}}>&nbsp;Youtube</Box></Box>
											<Box as={Arrow} className={'arrow'}  display={{base:'none', lg:'block'}} opacity={'0'} transition={'all .35s ease'}/>
										</Flex>
									}
								</Flex>
							}

							<Box >
								{img &&
									<Box as = {GatsbyImage} image={img} loading={'eager'} alt={article.title ?? 'grafika'} transition={'all 0.3s ease-out'} mb='60px' />
								}

								{article.knowledgeBaseACF && article.knowledgeBaseACF.spotify &&
									<Box borderBottom="1px solid #DBE1EA" borderTop="1px solid #DBE1EA"
										 mb={{base: '10px', lg: '20px', xxl: '30px'}}
										//  mb={{base: '10px', lg: '20px', xxl: '30px'}}
										 pb={{base: '10px', lg: '20px', xxl: '30px'}}
										 pt={{base: '10px', lg: '20px', xxl: '30px'}}>
										<Box fontSize={{base: '12px', lg: '16px'}} fontWeight="bold"
											 mb={{base: '10px', lg: '20px', xxl: '30px'}}>Przesłuchaj ten artykuł</Box>

										<iframe title="Spotify"
											src={article.knowledgeBaseACF.spotify.replace("episode","embed/episode")}
											width="100%" height="100" frameBorder="0" allowFullScreen=""
											allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
											loading="lazy"></iframe>

									</Box>
								}
								<Box fontSize={{base: '16px', lg: '20px'}}><PostContent post={article}>{article.content}</PostContent></Box>
								{isFAQ && <FaqHTML content={article.faqACF} />}
								{article.footnotes && article.footnotes.item && <Footnotes lang={lang} content={article.footnotes} />}
							</Box>
						</Container>
					</GridItem>
					<GridItem>
						<>
							<Box id='stickyContactForm'
								 position={{base:'fixed',xl:'sticky'}}
								 w={{base: '100%',xl:'calc(100% - 20px)', xxl: '100%'}} maxW={{base:'none', lg:'50%',xl: '400px'}}
								 top={{base:'0', xl: '30px'}}
								// left={{base:'0', xl: 'auto'}}
								 right={{base:'0', xl: 'auto'}}
								 bottom={{base:'0', xl: 'auto'}}
								 background={'#FFF'}
								 padding={{base: '20px', xl:'30px',xxl: '40px'}}
								 boxShadow={'0 30px 60px #0000001F'}
								 transition={'all 0.3s ease-out'}
								 ml={{xl:'20px', xxl:'0'}}
								 display={{ base: mobileFormActive ? 'block' : 'none', xl: 'block'}}
								 zIndex={mobileFormActive ? '1100' : '0'}
							>
								<Box className={'tableHeader'} cursor={'pointer'} display={{base: 'flex', xl: 'none'}} alignItems={'center'} position={'relative'}
									 mx={'-20px'} borderBottom={'1px solid'} borderColor={'gray.light'} mb={'20px'}
								>
									<HeaderWithLine text={lang && lang === "PL" ? 'Formularz kontaktowy' : 'Contact form'} mt={'0'} mb={'20px'} pb={{base:'0'}} linecolor={'gray.light'} fontSize={'15px'} ml={{base:'20px'}}/>
									<Box onClick={closeMobileForm} as={Close} position={'absolute'} right={'20px'} top={'0px'} display={{base:'block', xl: 'none'}} id={'closeFormOnMobile'}/>
								</Box>
								<ContactForm placement={'content'} ommit={'fullName'} formmarketingfields={article.knowledgeBaseACF} lang={lang} mx={{base:'auto', lg:'0'}} maxW={{base: 'calc(100% - 20px)', xl:'400px'}}/>
							</Box>
						</>
					</GridItem>
				</Grid>
				<Box onClick={openMobileForm} id='formToggle' cursor={'pointer'} position={'fixed'} bottom={'20px'} right={'20px'} width={'50px'} height={'50px'} zIndex={'5'} display={{lg: 'block', xl: 'none'}}
					 borderRadius={'50%'} animation={pulseAnimation}
				>
					<Box as={FormToggle} sx={{ 'svg' : {dropShadow: '0 10 30 #6B8FCA4D'}}} width={'50px'} height={'50px'}/>
				</Box>
			</Container>
			{author !== null && author.userFields &&
				<AuthorSection author={author} type={'article'} lang={lang}/>
			}
			<RatingComponent post={article} padding={{ base: '60px 10px 10px 10px', lg: '80px 80px 0 80px'}}/>
			{other &&
				<PrevNext other={other} lang={lang}/>
			}
			{interested &&
				<Interested interested={interested} lang={lang}/>
			}
		</>
	)
}

export const query = graphql`
	fragment KnowledgeBaseDefaultInformation on WpKnowledgeBase {
		contentType{
			node{
				name
			}
		}
		content
		  readingTime {
			time
		  }
		date(fromNow: true, locale: "pl")
		datePL: dateGmt(formatString: "DD MMMM YYYY", locale: "pl")
		modifiedPL : modified(formatString: "DD MMMM YYYY", locale: "pl")
		dateEN: dateGmt(formatString: "DD MMMM YYYY", locale: "en")
		modifiedEN : modified(formatString: "DD MMMM YYYY", locale: "en")
		schemaDate:dateGmt
		schemaModified:modified
		categories:knowledgeBaseCategories {
			nodes {
				name
				uri
				id
			}
		}
		uri
		author {
			node {
				name
				slug
				avatar {
					url
				}
				description
				userFields {
					cytat
				    cytatEn
				    krotkiOpis
				    krotkiOpisEn
				    stanowisko
				    stanowiskoEn
					socialMedia {
					  link
					  service
  				    } 
				}
			}
		}
		featuredImage {
			node {
				sizes
				filename
				publicUrl
				localFile {
					relativePath
					childImageSharp {
						id
						gatsbyImageData(
							width: 768
							placeholder: NONE
							quality: 70
							formats: [AUTO, WEBP]
							layout: CONSTRAINED
						)
					}
				}
			}
		}
	  	faqACF {
			faq {
			  answer
			  question
			}
      	}	
      	ratings{
      		userRating
      		voteCount
      	}
      	footnotes {
			item {
			  id
			  url
			  anchor
			  text
			  description
			}
		  }
		knowledgeBaseACF {
			formheader
			formsubtitle
			isRecommended
			showmarketingform
			tableofcontents
			spotify
        	youtube
		}
	}
`